export default "__VITE_ASSET__CSxT_Zd2__"